import React from "react";
import { useNavigate } from "react-router-dom";

function ResetSuccess() {
    const navigate = useNavigate();

    return (
        <div style={{
            maxWidth: "500px",
            margin: "auto",
            padding: "40px",
            textAlign: "center",
        }}>
            <h2>✅ Password Reset Successful</h2>
            <p>Your password has been updated. You can now log in with your new credentials.</p>

            <button
                onClick={() => navigate("/login")}
                style={{
                    marginTop: "20px",
                    padding: "10px 20px",
                    backgroundColor: "#007bff",
                    color: "white",
                    fontWeight: "bold",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                }}
            >
                Go to Login
            </button>
        </div>
    );
}

export default ResetSuccess;